import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyLoaderCss = ":host{--count:12;display:block;animation:spin 0.75s infinite steps(var(--count));height:32px;width:32px;position:relative;color:#000000}@keyframes spin{to{transform:rotate(360deg)}}span{background:currentColor;height:25%;left:50%;position:absolute;top:50%;transform:translate(-50%, -50%) rotate(calc(((360 / var(--count)) * var(--index)) * 1deg)) translate(0, -125%);width:10%;border-top-right-radius:1000px;border-top-left-radius:1000px}span{opacity:calc(var(--index) / var(--count))}";
const MapyLoaderStyle0 = mapyLoaderCss;

const MapyLoader = /*@__PURE__*/ proxyCustomElement(class MapyLoader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return h(Host, null, h("span", { style: { '--index': 1 } }), h("span", { style: { '--index': 2 } }), h("span", { style: { '--index': 3 } }), h("span", { style: { '--index': 4 } }), h("span", { style: { '--index': 5 } }), h("span", { style: { '--index': 6 } }), h("span", { style: { '--index': 7 } }), h("span", { style: { '--index': 8 } }), h("span", { style: { '--index': 9 } }), h("span", { style: { '--index': 10 } }), h("span", { style: { '--index': 11 } }), h("span", { style: { '--index': 12 } }));
    }
    static get style() { return MapyLoaderStyle0; }
}, [1, "mapy-loader"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyLoader);
            }
            break;
    } });
}
defineCustomElement();

export { MapyLoader as M, defineCustomElement as d };

//# sourceMappingURL=mapy-loader2.js.map